import { fetchGet, fetchPost, fetchPut } from '.';
import { constructQueryString } from '../utils/constructQueryString';

export const fetchClients = async (options = {}) => {
  const queryString = constructQueryString(options);
  return await fetchGet(`/client${queryString}`);
};

export const createClient = async (body) => {
  return await fetchPost('/client', body);
};

export const updateClient = async (uuid, body) => {
  console.log('body', body);
  return await fetchPut(`/client/${uuid}`, body);
};

export const fetchClient = async (uuid) => {
  return await fetchGet('/client/' + uuid);
};
